import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import PageHeader from "../../shared/components/PageHeader";
import QuickLinks from "./components/QuickLinks";
import { Alert } from "reactstrap";
import { MdClear } from "react-icons/md";
import alertLogo from "../../assets/images/warning.png";
// import ActiveCampaignsTable from "./components/ActiveDisbursementTable";
import { connect } from "react-redux";
import { getCurrentStatus } from "../CurrentUser/actions/currentUser.actions";
const Dashboard = (props) => {
    const { dispatch, currentUser, currentUserStatus } = props;
    const [isUserEnable, setIsUserEnable] = useState(false);
    // useEffect(() => {
    //     if (currentUser.currentUser && currentUser.currentUser.response && currentUser.currentUser.response.email) {
    //         if (currentUserStatus && currentUserStatus.response) {
    //             if (!currentUserStatus.response.enabled) {
    //                 setIsUserEnable(true);
    //             }
    //         } else {
    //             dispatch(getCurrentStatus({ username: currentUser.currentUser.response.email }));
    //         }
    //     }

    //     return () => {
    //         setIsUserEnable(true);
    //     };
    // }, [dispatch]);
    // useEffect(() => {
    //     if (currentUser.currentUser && currentUser.currentUser.response && currentUser.currentUser.response.email) {
    //         if (currentUserStatus && currentUserStatus.response) {
    //             if (!currentUserStatus.response.enabled) {
    //                 setIsUserEnable(true);
    //             } else {
    //                 setIsUserEnable(false);
    //             }
    //         }
    //     }
    // }, [currentUserStatus && currentUserStatus.response && currentUserStatus.response.enabled]);
    // const closeDisableModal = () => {
    //     setIsUserEnable(false);
    // };
    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <PageHeader header="Dashboard" />
                </Col>
            </Row>
            <Row>
                <Col lg={{ size: 12 }}>
                    <Row>
                        <Col>
                            <QuickLinks />
                        </Col>
                    </Row>
                </Col>
            </Row>
            {/* {isUserEnable ? (
                <div className="app-load-error">
                    <Alert color="light">
                        <MdClear size={30} style={{ color: "red", position: "absolute", right: "31px", cursor: "pointer" }} onClick={() => closeDisableModal()} />

                        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50pt" height="50pt" viewBox="0 0 500.000000 500.000000" preserveAspectRatio="xMidYMid meet">
                            <g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                                <path
                                    d="M2367 4660 c-103 -33 -187 -110 -279 -258 -81 -128 -192 -319 -206
                                    -352 -7 -19 -33 -64 -56 -100 -24 -36 -90 -143 -147 -239 -57 -95 -124 -205
                                    -148 -245 -23 -39 -66 -114 -93 -166 -28 -52 -74 -131 -102 -175 -59 -90 -227
                                    -372 -297 -498 -25 -45 -80 -138 -122 -207 -99 -164 -277 -465 -302 -512 -22
                                    -41 -214 -360 -317 -528 -36 -58 -77 -130 -92 -160 -14 -30 -46 -86 -71 -125
                                    -145 -227 -165 -356 -83 -525 42 -87 147 -190 226 -222 l57 -23 2165 0 2165 0
                                    57 23 c79 32 184 135 227 222 83 171 62 295 -90 535 -27 44 -61 103 -74 130
                                    -13 28 -47 89 -77 137 -179 294 -306 503 -323 536 -26 49 -206 353 -306 517
                                    -43 72 -95 162 -115 200 -19 39 -41 77 -48 85 -7 8 -63 101 -125 205 -62 105
                                    -133 222 -157 260 -24 39 -61 104 -82 145 -22 41 -59 107 -83 147 -24 39 -91
                                    149 -148 245 -57 95 -123 203 -147 239 -24 37 -48 79 -54 95 -10 25 -129 229
                                    -225 384 -78 126 -163 199 -267 232 -76 23 -185 23 -261 -2z m223 -570 c47
                                    -77 94 -157 104 -177 19 -39 157 -271 292 -493 42 -69 97 -163 121 -210 25
                                    -47 51 -92 58 -100 6 -8 63 -100 125 -205 62 -104 137 -230 168 -280 30 -49
                                    71 -121 90 -160 19 -38 54 -99 77 -135 24 -36 93 -150 155 -255 61 -104 118
                                    -197 125 -205 8 -8 32 -51 54 -95 22 -44 76 -138 119 -210 132 -216 292 -484
                                    292 -490 0 -2 41 -72 90 -155 50 -83 90 -153 90 -155 0 -3 -151 -5 -335 -5
                                    -368 0 -398 -4 -411 -54 -6 -25 -9 -26 -78 -26 -69 0 -72 1 -84 29 -8 18 -25
                                    34 -44 40 -22 8 -498 11 -1589 11 -858 0 -1559 2 -1559 6 0 3 41 72 90 155 50
                                    82 90 152 90 155 0 6 175 301 298 501 45 73 98 165 117 205 20 40 42 80 50 88
                                    7 8 66 105 131 215 64 110 127 214 140 230 12 17 45 74 73 127 28 53 75 137
                                    105 185 30 48 105 174 167 278 62 105 118 197 125 205 6 8 32 53 56 100 25 47
                                    82 146 128 220 147 240 233 384 269 452 54 100 203 348 210 348 4 0 45 -63 91
                                    -140z"
                                    fill="#FF0000"
                                />
                                <path
                                    d="M2422 3325 c-88 -27 -141 -83 -178 -188 -13 -38 -13 -67 7 -307 22
-277 31 -316 71 -322 20 -3 23 -9 26 -60 2 -47 0 -58 -12 -58 -9 0 -23 -11
-32 -25 -18 -27 -17 -88 7 -395 15 -191 31 -230 110 -270 95 -49 216 1 248
103 10 34 27 224 37 427 3 69 19 291 35 494 32 402 33 395 -22 491 -32 57 -76
90 -145 111 -57 17 -95 17 -152 -1z"
                                    fill="#000000"
                                />
                                <path
                                    d="M2429 1524 c-114 -35 -174 -144 -148 -267 15 -75 42 -114 103 -151
41 -26 58 -30 116 -30 58 0 75 4 116 30 61 37 88 76 103 151 27 125 -34 233
-152 268 -61 18 -78 18 -138 -1z"
                                    fill="#000000"
                                />
                            </g>
                        </svg>
                        <h4 className="font-weight-bold mb-3" style={{ color: "red" }}>
                            {" "}
                            ACCESS DENIED!
                        </h4>
                        <h4 className="font-weight-bold" style={{ color: "black" }}>
                            Your account has been disabled.
                        </h4>
                        <p style={{ color: "black", fontSize: "" }}>Please contact the administrator to enable access to Bulk Paycode Disbursement portal.</p>
                    </Alert>
                </div>
            ) : null} */}
        </Container>
    );
};
export default connect((state) => ({
    currentUser: state,
    currentUserStatus: state.getCurrentUserStatus,
}))(Dashboard);
